import React from "react";
import { Button, Typography } from "@mui/material";

import DialogComponent from "../../../common/components/DialogComponent.jsx";
import { VARIANTS, BUTTON_COLORS } from "../../../common/constants/commonConstants.js";

const DeleteScheduleDailog = ({ open, onConfirm, onClose, schedule }) => {
  return (
    <div>
      <DialogComponent
        open={open}
        onClose={onClose}
        title={"Delete Schedule"}
        actions={
          <Button
            onClick={onConfirm}
            color={BUTTON_COLORS.PRIMARY}
            variant={VARIANTS.CONTAINED}
          >
            Confirm
          </Button>
        }
      >
        <Typography variant={VARIANTS.BODY}>
          {`Are you sure you want to delete the schedule "${schedule?.name || "this schedule"}"? This action cannot be undone.`}
        </Typography>
      </DialogComponent>
    </div>
  );
};

export default DeleteScheduleDailog;
